import { render, staticRenderFns } from "./pd-top-links.vue?vue&type=template&id=6d5a47c6&"
import script from "./pd-top-links.vue?vue&type=script&lang=js&"
export * from "./pd-top-links.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SgLink: require('/opt/build/repo/storefront/components/legacy/global/sg-link.vue').default})
